<!--
 * @Author: He Lang
 * @Date: 2021-05-20 10:15:19
 * @LastEditTime: 2023-10-13 15:25:07
 * @LastEditors: zhujuan zhujuan@winning.com.cn
 * @Description: 下发整改弹框
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_components/dialog/PlanEditDialog.vue
-->
<template>
  <el-dialog
    v-dialogDrag
    :visible.sync="dialogVisible"
    width="100%"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :before-close="dialogClose"
  >
    <div slot="title" class="title-container">
      <img class="logo" src="@/common/assets/images/login-logo.svg" />
      <div class="text">{{ isReview ? '查看改进计划' : '下发整改' }}</div>
    </div>
    <section class="form">
      <div class="tool">
        <span class="form_title">问题列表</span>
        <more-cols
          ref="moreCols"
          class="mr-10 wn-fr"
          :show-table-col-list="tableColumns"
          :show-table-check-list.sync="showDefaultTable"
          @getLastCheckList="getLastCheckList"
        ></more-cols>
      </div>
      <div class="tables_contain">
        <w-table
          ref="wtTable"
          v-win-loading="tableLoading"
          class="tables"
          border
          :data="detailData"
          stripe
          highlight-current-row
          height="100%"
        >
          <w-table-column type="index" label="序号" width="70" align="center">
          </w-table-column>
          <w-table-column
            v-for="(item, index) in showDefaultTable"
            :key="index"
            :label="item.name"
            :prop="item.key"
            :width="item.width"
            :align="item.align"
          >
          </w-table-column>
          <w-table-column
            label="整改类型"
            width="120"
            prop="Zglx"
            fixed="right"
          >
            <template slot-scope="scope">
              <w-select
                v-if="!isReview"
                v-model="scope.row.Zglx"
                @change="setZglx(scope)"
              >
                <w-option
                  v-if="smzgStatus"
                  label="书面整改"
                  value="0"
                ></w-option>
                <w-option
                  v-if="jszgStatus && scope.row.SFBXZG !== 1"
                  label="及时整改"
                  value="1"
                ></w-option>
              </w-select>
              <span v-else>{{
                scope.row.Zglx === '0' ? '书面整改' : '及时整改'
              }}</span>
            </template>
          </w-table-column>
          <w-table-column
            label="整改要点"
            width="190"
            prop="Zgyd"
            fixed="right"
          >
            <template slot-scope="scope">
              <w-input
                v-if="!isReview"
                v-model="scope.row.Zgyd"
                type="textarea"
                :row="5"
                :maxlength="1000"
                @blur="setZglx(scope)"
              >
              </w-input>
              <w-button
                v-if="!isReview"
                type="text"
                @click="popZsk(scope, 'Zgyd', '1206')"
                >引用模板
              </w-button>
              <span v-if="isReview">{{ scope.row.Zgyd }}</span>
            </template>
          </w-table-column>
          <w-table-column
            label="接收科室"
            width="150"
            prop="Ksdm"
            fixed="right"
          >
            <template slot-scope="scope">
              <span v-if="isReview">{{
                scope.row.NeedShowProblemInfoList[0].Ksmc
              }}</span>
              <div
                v-for="(item, index) in scope.row.ksList"
                :key="index"
                class="jsks_box"
              >
                <w-tree-select
                  v-if="!isReview"
                  ref="DynamicTree"
                  v-model="item.value"
                  popover-class="selectTree"
                  :popper-append-to-body="false"
                  v-bind="treeSelectParams"
                  collapse-tags
                  :disabled="isReview"
                  size="medium"
                  @search="searchFun"
                  @node-click="handleKsChange($event, scope, index)"
                  @select-clear="handleKsChange($event, scope.row)"
                ></w-tree-select>
              </div>
            </template>
          </w-table-column>
          <w-table-column label="接收人" width="140" prop="Jsrqc" fixed="right">
            <template slot-scope="scope">
              <div v-if="isReview">
                {{ scope.row.Jsrmc }}
              </div>
              <div
                v-for="(item, index) in scope.row.NeedShowProblemInfoList"
                :key="index"
                class="jsr"
                style="margin-top: 8px"
              >
                <popover-receive
                  v-if="!isReview"
                  value-key="Jsr"
                  value-name="Jsrqc"
                  :disabled="!scope.row.Jsrqc && scope.row.isAdd"
                  :is-add="scope.row.isAdd"
                  :index="scope.$index"
                  :row="scope.row"
                  :item="item"
                  :merge-index="index"
                  @changeValue="changeJsr"
                >
                </popover-receive>
              </div>
            </template>
          </w-table-column>
          <w-table-column
            v-if="!isReview"
            label="操作"
            align="center"
            width="70"
            fixed="right"
          >
            <template slot-scope="scope">
              <div
                v-for="(item, index) in scope.row.ksList"
                :key="index"
                class="operate"
              >
                <i
                  v-if="!item.IsAdd"
                  :value="item.IsAdd"
                  class="w-icon-plus icon-plus-logo"
                  @click="addQuestionList(scope)"
                ></i>
                <img
                  v-else
                  src="@/common/assets/images/del.png"
                  class="arrow"
                  @click="delQuestionList(scope, index)"
                />
              </div>
            </template>
          </w-table-column>
        </w-table>
      </div>

      <w-form ref="planForm" class="planForm" :rules="rules" :model="formData">
        <w-row :gutter="24">
          <w-col :span="12">
            <w-form-item
              class="xfr_form"
              label="下发人："
              :prop="isReview ? '' : 'Xfr'"
              label-width="80px"
            >
              <w-input v-if="!isReview" v-model="formData.Xfr" :readonly="true">
              </w-input>
              <span v-if="isReview">{{ formData.Xfr }}</span>
            </w-form-item>
          </w-col>
          <w-col :span="12">
            <w-form-item
              label="下发时间："
              :prop="isReview ? '' : 'Xfsj'"
              label-width="100px"
            >
              <w-date-picker
                v-if="!isReview"
                v-model="formData.Xfsj"
                type="date"
                format="yyyy-MM-dd"
                placeholder="请选择时间"
                :clearable="false"
              ></w-date-picker>
              <span v-if="isReview">{{
                moment(formData.Xfsj).format('YYYY-MM-DD')
              }}</span>
            </w-form-item>
          </w-col>
        </w-row>
      </w-form>
    </section>

    <div class="modal-window-footer">
      <div class="window-footer-btns">
        <w-button :disabled="loading" @click="exit()"> 取消 </w-button>
        <w-button
          v-if="!isReview"
          type="primary"
          :disabled="loading"
          @click="saveSubmit('1')"
        >
          保存
        </w-button>
        <w-button
          v-if="!isReview"
          type="primary"
          :disabled="loading"
          @click="saveSubmit('2')"
        >
          {{ formData.Zglx == 0 ? '下发' : '提交' }}
        </w-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PopoverReceive from '@/common/components/PopoverReceive'
import moment from 'moment'
import zskSelect from '../../../../qc-rectification/qualityImprovementEvaluation/_components/dialog/zskSelect.vue'
import { GetIssuedPlan, GetZZjgByZkjbAndUser } from '../../_api/index.js'
import MoreCols from '@/common/components/MoreCols'
export default {
  name: 'DetailDialog',
  components: {
    PopoverReceive,
    zskSelect,
    MoreCols
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => false
    },
    dialogClose: {
      type: Function,
      default: () => {}
    },
    selectedArr: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line
    Zkjb: {
      type: [Number, String],
      default: () => null
    },
    isReview: {
      type: Boolean,
      default: () => false
    },
    hospitalCode: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      value: 1,
      rules: {
        Xfr: [{ required: true, message: '请填写下发人' }],
        Xfsj: [
          {
            required: true,
            type: 'date',
            message: '请选择下发时间'
          }
        ],
        PlanShowList: [
          {
            required: true,
            type: 'array',
            message: '请填写问题列表'
          }
        ],
        Zglx: [{ required: true, message: '请选择整改类型' }]
      },
      formData: {
        Ksmc: '',
        Wtsl: '',
        Jsrqc: '',
        Xfr: '',
        Zglx: '0',
        Jsrmc: '',
        PlanShowList: [],
        PlanDetailList: [],
        Xfsj: new Date(),
        Zgyd: '',
        IssuedPlanItemList: []
      },
      UserInfo: {},
      treeSelectParams: {
        multiple: false,
        clearable: true,
        filterable: true,
        placeholder: '请选择',
        filterable: false,
        'check-strictly': true,
        'default-expand-all': true,
        'expand-on-click-node': false,
        treeClickParent: true,
        treeData: [],
        treeProps: {
          children: 'Child',
          label: 'name',
          value: 'id',
          disabled: 'disabled'
        }
      },
      loading: false,
      tableLoading: false,
      detailData: [],
      showTableCheckArray: [],
      tableColumns: [
        {
          name: '受检科室',
          key: 'JCFW_MC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          align: 'center',
          width: '220',
          keepChoosing: false,
          checked: true
        },
        {
          name: '存在问题',
          key: 'CZWT',
          align: 'center',
          width: '220',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'JGZMC',
          width: '80',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '问题来源',
          key: 'ZKJBMC',
          width: '180',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '督查时间',
          key: 'DCSJ',
          width: '180',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '被查人',
          key: 'BCR',
          width: '180',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '责任人',
          key: 'ZRR',
          width: '180',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '备注',
          key: 'MEMO',
          width: '160',
          align: 'center',
          keepChoosing: false,
          checked: false
        }
      ],
      showDefaultTable: [
        {
          name: '受检科室',
          key: 'JCFW_MC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '存在问题',
          key: 'BZMC',
          align: 'center',
          width: '220',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'center',
          width: '220',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'JGZMC',
          width: '180',
          align: 'center',
          keepChoosing: true,
          checked: true
        }
      ],
      sourceData: [],
      jszgStatus: true,
      smzgStatus: true
    }
  },
  computed: {
    checkBXZG() {
      return this.selectedArr.some((m) => m.SFBXZG == 1)
    }
  },
  created() {
    console.log(1)
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.getSystemSetting()
    if (!this.isReview) {
      this.getDepList()
    } else {
      this.getDataList()
    }
  },
  mounted() {
    //this.getDataList()
  },
  methods: {
    getSystemSetting() {
      this.$requestApi('GetXTMJList', { Mjlx: '018' }).then((res) => {
        if (res.success) {
          this.jszgStatus = res.data.find((m) => m.MJDM == 1072)?.JLZT == '1'
          this.smzgStatus = res.data.find((m) => m.MJDM == 1071)?.JLZT == '1'
        }
      })
    },
    handleData(data) {
      if (data.Jsrmc == null || data.Jsrmc == '') {
        return ''
      } else {
        return data.Jsrmc.includes('(') === true
          ? `${data.Jsrmc}`
          : `${data.Jsrmc}(${data.Jsr})`
      }
    },
    //接收人 赋值
    changeJsr(row, index, count) {
      if (row.isErgodicList) {
        row.jsrArr[count].Jsrqc = row.Jsrqc
        row.jsrArr[count].Jsr = row.Jsr

        // 更新数据
        row.NeedShowProblemInfoList[count].JsrList = row.JsrList
        row.NeedShowProblemInfoList[count].Jsr = row.Jsr
        row.NeedShowProblemInfoList[count].Jsrmc = row.Jsrqc.slice(
          0,
          row.Jsrqc.indexOf('(')
        )
      }

      //更新页面渲染显示的数据
      this.$nextTick(() => {
        this.$set(this.detailData, index, row)
      })
    },
    removeJsr(row, index) {
      row.Jsr = ''
      row.Jsrqc = ''
      this.$set(this.detailData, index, row)
    },
    getDataList() {
      this.tableLoading = true
      this.formData.Zglx =
        this.selectedArr[0].ZGLX == '书面整改'
          ? 0
          : this.selectedArr[0].ZGLX == '及时整改'
          ? 1
          : ''
      let selectedDataList = this.selectedArr.map((item) => {
        return {
          Ksdm: item.KSDM || item.JCFW,
          Ksmc: item.KSMC || item.JCFW_MC,
          Cfxh: item.CFXH,
          Xfxh: item.XFXH,
          Kfxdm: item.KFXDM,
          Kfz: item.KFJG,
          XFWD: item.XFWD || 20
        }
      })
      let params = {
        SelectedProblemInfoList: selectedDataList,
        Zkjb: this.Zkjb
      }
      let that = this
      that.detailData = []
      GetIssuedPlan(params)
        .then((res) => {
          if (res.success) {
            this.formData = res.data
            this.sourceData = res.data.IssuedPlanItemList
            // 把请求的数据，筛选过滤，最后赋值给问题列表的detailData
            if (res.data && res.data.IssuedPlanItemList) {
              let index = 0
              res.data.IssuedPlanItemList.forEach((item) => {
                let temp = [...item.CheckDetailList]
                temp.forEach((m) => {
                  m.id = index
                  m.Xfxh = item.Xfxh
                  m.Cfxh = item.Cfxh
                  m.Kfxdm = item.Kfxdm
                  m.Ksdm = `${item.Ksdm}`
                  m.Jsr = item.Jsr || ''
                  let flag = ''
                  if (item.JsrList && item.JsrList !== null) {
                    flag = item.JsrList.find((k) => {
                      return k.Jsr == m.Jsr
                    })
                  }
                  m.Jsrmc = item.Jsrmc
                  m.Jsrqc = flag ? `${flag.Jsrmc}(${item.Jsr})` : ''
                  m.JsrList = item.NeedShowProblemInfoList[0].JsrList
                  m.Zgyd = item.Zgyd
                  ;(m.XFWD = item.XFWD),
                    //设置表单数据
                    (m.jsrArr = item.NeedShowProblemInfoList.map((items) => ({
                      Jsr: items.Jsr,
                      Jsrqc: this.handleData(items),
                      IsAdd: items.IsAdd
                    })))
                  m.ksList = item.NeedShowProblemInfoList.map((items) => ({
                    label: items.Ksmc,
                    value: items.Ksdm + '',
                    IsAdd: items.IsAdd
                  }))
                  m.isErgodicList = true
                  m.NeedShowProblemInfoList = item.NeedShowProblemInfoList
                  // 是否为必须整改,必须整改，只显示书面整改
                  m.Zglx = m.SFBXZG == 1 ? '0' : `${item.Zglx}`
                  m.JCKFYY = m.JCKFYY.replace(/^(\s|;)+|(\s|;)+$/g, '') //去除首尾分号
                })
                that.detailData = that.detailData.concat(temp)
                index++
              })
            }
            this.formData.Xfr = res.data.Xfr
              ? res.data.Xfr
              : this.UserInfo.username + '(' + this.UserInfo.UserId + ')'
          } else {
            this.$emit('close')
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    // 循环遍历递归方法
    forEachFun(data, that) {
      data.forEach((item) => {
        item.id = item.id.toString()
        item.disabled = item.JBDM !== 1003 || item.QYZT !== '1'
        if (item.Child && item.Child.length > 0) {
          this.forEachFun(item.Child, that)
        } else {
          return
        }
      })
    },
    searchFun(value) {
      this.$nextTick(() => {
        this.$refs.DynamicTree.$refs.tree.filter(value)
      })
    },
    addQuestionList(scope) {
      let index = scope.$index

      // 接收人和接收科室
      scope.row.ksList.push({ value: '', label: '', IsAdd: true })
      scope.row.jsrArr.push({ Jsr: '', Jsrqc: '', IsAdd: true })

      scope.row.NeedShowProblemInfoList.push({
        IsAdd: true,
        IsReadOnly: false,
        Jsr: '',
        JsrList: [],
        Jsrmc: '',
        Ksmc: '',
        Ksdm: 0
      })

      // 深拷贝数据
      let targetDetailData = JSON.parse(JSON.stringify(this.detailData))
      this.detailData = targetDetailData

      this.$set(this.detailData, index, scope.row)
    },
    delQuestionList(scope, count) {
      let index = scope.$index

      scope.row.ksList.splice(count, 1)
      scope.row.jsrArr.splice(count, 1)
      //删除数据
      scope.row.NeedShowProblemInfoList.splice(count, 1)
      // 深拷贝数据
      let targetDetailData = JSON.parse(JSON.stringify(this.detailData))
      this.detailData = targetDetailData

      this.$set(this.detailData, index, scope.row)
    },
    //更换接收科室
    handleKsChange(val, scope, index) {
      let rowIndex = scope.$index
      const currRow = JSON.parse(JSON.stringify(this.detailData[rowIndex]))
      // 更新数据
      currRow.ksList[index].value = val.id
      currRow.ksList[index].label = val.name

      currRow.NeedShowProblemInfoList[index].Ksdm = val.id
      currRow.NeedShowProblemInfoList[index].Ksmc = val.name
      //选择科室之后，接收人员变化
      let params = [
        {
          Ksdm: val.id,
          Ksmc: val.name,
          Cfxh: scope.row.Cfxh,
          Xfxh: scope.row.Xfxh,
          Kfxdm: scope.row.Kfxdm
        }
      ]

      let param = {
        SelectedProblemInfoList: params,
        Type: 'changeOrg',
        Zkjb: this.Zkjb
      }

      let that = this

      const currentKsdmSum = currRow.NeedShowProblemInfoList.filter(
        (v) => v.Ksdm == currRow.NeedShowProblemInfoList[index].Ksdm
      )
      const hasDefaultFlag = currentKsdmSum.length === 1

      GetIssuedPlan(param).then((res) => {
        if (res.success) {
          let targetData =
            res.data.IssuedPlanItemList[0].NeedShowProblemInfoList[0].JsrList
          // 设置表单数据
          let setData =
            res.data.IssuedPlanItemList[0].NeedShowProblemInfoList[0]

          currRow.Jsr = setData.Jsr
          currRow.JsrList = setData.JsrList
          currRow.Jsrqc = setData.Jsrmc

          currRow.jsrArr[index].Jsr = hasDefaultFlag ? setData.Jsr : ''
          currRow.jsrArr[index].Jsrqc = hasDefaultFlag ? setData.Jsrmc : ''

          //更新数据
          currRow.NeedShowProblemInfoList[index].JsrList = targetData

          currRow.NeedShowProblemInfoList[index].Jsr = hasDefaultFlag
            ? setData.Jsr
            : ''
          currRow.NeedShowProblemInfoList[index].Jsrmc = hasDefaultFlag
            ? setData.Jsrmc
            : ''

          //拷贝一下数据
          // let targetDetailData = JSON.parse(JSON.stringify(that.detailData))
          // that.detailData = targetDetailData
          // 更新数据
          this.$nextTick(() => {
            this.$set(this.detailData, rowIndex, currRow)
          })
        }
      })
    },
    // 保存
    saveSubmit(flag) {
      if (this.loading) {
        return
      }
      this.loading = true // 加防抖
      //生成提交的数据结构
      let submitData = this.detailData.map((item) => ({
        NeedShowProblemInfoList: item.NeedShowProblemInfoList,
        Zglx: item.Zglx,
        Zgyd: item.Zgyd,
        Cfxh: item.CFXH,
        Xfxh: item.Xfxh,
        Kfxdm: item.Kfxdm,
        Ksdm: item.Ksdm
      }))

      //接收人
      let validate = true
      //接收科室
      let validate1 = true
      //整改类型
      let validate2 = true

      //遍历数组，验证是否与没填写接收科室和接收人
      this.detailData.forEach((item) => {
        item.NeedShowProblemInfoList.forEach((items) => {
          if (!items.Jsr || !items.Jsr === '') {
            validate = false
          }
          if (!items.Ksdm || !items.Ksdm === '') {
            validate1 = false
          }
          items.Zglx = item.Zglx
          items.Zgyd = item.Zgyd
        })
        if (!item.Zglx || !item.Zglx === '') {
          validate2 = false
        }
      })
      // 选择及时整改时可以不选择接收人 需求 1005857
      if (!validate && this.formData.Zglx != 1) {
        this.$msg('存在下发数据，接收人员未选择', 'error')
        this.loading = false
        return
      }
      if (!validate1) {
        this.$msg('存在下发数据，科室数据未选择', 'error')
        this.loading = false
        return
      }
      if (!validate2) {
        this.$msg('存在下发数据，科室数据未选择整改类型', 'error')
        this.loading = false
        return
      }

      this.$requestApi('SaveIssuedPlan', {
        UserId: this.UserInfo.UserId,
        UserName: this.UserInfo.UserName,
        Zkjb: this.Zkjb,
        Xfr: this.UserInfo.UserName,
        Xfsj: moment(this.formData.Xfsj).format('YYYY-MM-DD'),
        IsSave: flag,
        SelectedProblemInfoList: submitData,
        HospitalCode: this.hospitalCode
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              if (flag === '2') {
                this.$msg('下发成功', 'success')
                this.dialogClose()
              } else {
                this.$msg('保存成功', 'success')
              }
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 下发
    pullSubmit() {},
    exit() {
      if (this.isReview) {
        this.dialogClose()
      } else {
        this.$Confirm('确定要取消本次操作吗？', '提示', {
          showCancelButton: true,
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        })
          .then(() => {
            this.dialogClose()
          })
          .catch(() => {})
      }
    },
    //弹出知识库选择框
    popZsk(datas, prop, type) {
      let obj = datas.row
      let count = datas.$index
      let quote = [
        {
          IsAdd: false,
          IsReadOnly: false,
          Jsr: obj.Jsr,
          JsrList: obj.JsrList,
          Ksdm: obj.Ksdm,
          Ksmc: obj.Ksmc
        }
      ]
      let that = this
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.7
      let bddms = this.selectedArr.map((m) => m.BDDM).join(',')
      var index = this.$dlg.modal(zskSelect, {
        title: '知识库-整改要点',
        width: width,
        height: height,
        params: {
          zskLx: type,
          bddms: bddms,
          zzjgdms: [
            ...new Set(
              quote.map((i) => {
                return i.Ksdm
              })
            )
          ].join(',')
        },
        callback: (data) => {
          if (data && data.length > 0) {
            var str = data.map((m) => m.MEMO).join(';')
            datas.row.Zgyd = `${datas.row.Zgyd || ''}${str}`
            //str = (obj[prop] || '') + str
            // that.$set(obj, prop, str)
            this.$set(this.detailData, count, datas.row)
          }
        },
        cancelCallback: () => {}
      })
    },
    getDepList() {
      //获取科室数据
      GetZZjgByZkjbAndUser({
        // CheckZzjgdm: this.selectedArr[0].KSDM,
        CheckZzjgdm: this.selectedArr.map((m) => m.KSDM).join(','),
        UserId: this.UserInfo.UserId,
        Zkjb: this.Zkjb,
        HospitalCode: this.hospitalCode
      }).then((res) => {
        if (res.success) {
          this.forEachFun(res.data, this)
          this.treeSelectParams.treeData = res.data
          //特殊树形结构
          if (res.data.length == 1 && res.data[0].Child.length == 0) {
            this.specialValue = res.data[0].id
          }
          this.getDataList()
        }
      })
    },
    getLastCheckList(val) {
      if (val.length > 0) {
        localStorage.setItem(
          `rectification${this.activeName}`,
          JSON.stringify({
            showTableCheckList: val,
            xtmj1193: this.xtmj1193
          })
        )
      } else {
        localStorage.removeItem(`rectification${this.activeName}`)
      }
    },
    setZglx(data) {
      //这时候组件不会重新渲染，需要重新设置值
      this.$set(this.detailData, data.$index, data.row)
    }
  },
  windowConfigs: {
    maxButton: false,
    width: document.body.clientWidth,
    height: document.body.clientHeight
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-bottom: 20px;
}

.planForm {
  margin-top: 20px;
}
.table-title {
  font-size: 13px;
  color: #666;
  margin: 5px 0;
  font-weight: bold;
}
.arrow {
  cursor: pointer;
}
.window-footer-btns {
  float: right;
}
/deep/ .el-dialog__header {
  background-color: var(--COLOR-NORMAL-BG);
  padding: 10px 20px;
  .el-dialog__title {
    color: #303133;
  }
  .el-dialog__close {
    font-size: 22px;
    transform: translateY(-5px);
  }
}

.form_title {
  font-weight: 600;
  line-height: 36px;
}

.title-container {
  display: flex;
  font-weight: 700;
  .logo {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }
  .text {
    height: 24px;
    line-height: 24px;
  }
}
.jsks_box {
  margin-top: 8px;
}
.operate {
  margin-top: 8px;
  img {
    margin-top: 10px;
  }
}
/deep/ .w-table__body-wrapper {
  height: 45vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 13px !important;
  }
}
.xfr_form {
  width: 40%;
}
/deep/ .el-dialog {
  width: 92% !important;
  height: 90%;
  margin-top: 3vh !important;
}

.tables {
  height: 100%;
  height: 100%;
}

.w-table {
  th {
    .cell {
      padding: 0px !important;
    }
  }
}

/deep/ .w-table__row td:nth-last-child(2) {
  border-right: 1px solid #c9c9c9 !important;
}
// .tables_contain{
//   padding-bottom: 16px;
//   height: 100vh;
// }

// /deep/ .w-table__fixed-right{
//   height: 49vh !important;
// }
</style>
